import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CollectionResource } from '@app/data/resources';
import { PlanType } from '@app/data/enums';
import { PlanResource } from './resources';
import { SubscriptionPlanFilterInput } from './inputs';

export default class SubscriptionPlan {
    private basePath = '/api/subscription-plan';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Force-sync subscription from external source
    get = async (
        planType: PlanType,
        filter?: SubscriptionPlanFilterInput
    ): Promise<CollectionResource<PlanResource, {}>> => {
        const query = qs.stringify({ ...(filter || {}) });

        const { data } = await this.http.get(`${this.basePath}/${planType}?${query}`);

        return data;
    };
}
